import { useCallback, useEffect, useState } from 'react';

import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

export const useWebp = () => {
    const [{ webP: supportsWebP }, setWebPSupport] = useState({ webP: true });
    const webPCheck = useCallback(() => new Promise(resolve => {
        const image = new Image();
        image.onerror = () => resolve(false);
        image.onload = () => resolve(image.width === 1);
        image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
    }).catch(() => false), []);

    useEffect(() => {
        const checkForSupport = async() => {
            const browserSupportsWebP = await webPCheck();

            // @ts-ignore
            setWebPSupport({ webP: browserSupportsWebP });
        };
        checkForSupport();
    }, []);

    return supportsWebP;
};

/**
 * Если нельзя использовать хук выше
 * Возвращает true если браузер поддерживает webp
 * Должен использоваться только на стороне браузера
 */
export const isWebp = async(): Promise<boolean> => {
    if (isServerSide()) {
        throw new Error('Проверка isWebp(), вызвана на стороне сервера (SSR)!');
    }

    return new Promise<boolean>(resolve => {
        const image = new Image();
        image.onerror = () => resolve(false);
        image.onload = () => resolve(image.width === 1);
        image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
    }).catch(() => false);
};
